const css = `.eUI7JW__scrollable{border-radius:inherit;overflow-y:auto}.eUI7JW__rightAdornment svg{color:inherit}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"scrollable":"eUI7JW__scrollable","rightAdornment":"eUI7JW__rightAdornment"};
